import React, { useState } from "react";
import Slider from "react-slick";
import useStyles, { FormInputSelect } from "./styles";
import Navbar2 from "../../components/Navbar2/Navbar2";
import Section from "../../components/Section/Section";
import Footer from "../../components/Footer/Footer";
import FormInputNoLabel from "../../components/FormInputNoLabel/FormInputNoLabel";
import Paragraph from "../../components/Typography/Paragraph";
import Card from "../../components/Card/Card";
import Loader from "react-js-loader";

import giftbox from "../../assets/images/giftbox.png";
import wallet from "../../assets/images/wallet.png";
import slot from "../../assets/images/slot.png";
import result from "../../assets/images/result.png";
import event from "../../assets/images/event.png";
import subscribe from "../../assets/images/subscribe.png";

import {
  Container,
  Grid,
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Table,
  TableContainer,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  IconButton,
  Collapse,
  Select,
  MenuItem,
  Dialog,
  DialogTitle,
  DialogContent,
  RadioGroup,
  Radio,
  FormControlLabel,
  TablePagination,
  Stack,
  Checkbox,
  Box,
} from "@mui/material";
import Button from "../../components/Button/Button";
import {
  AddCircle,
  MoreVert,
  Edit,
  Delete,
  RemoveCircle,
} from "@mui/icons-material";
import {
  get_shipping_charge,
  add_shipping_charge,
  edit_shipping_charge,
  delete_shipping_charge,
  get_category,
  get_shipping_country,
  edit_shipping_country,
  get_custom_made,
  delete_custom_made,
} from "../../API/API";
import Countdown from "react-countdown";
import moment from "moment/moment";

import "./styles.css";
import FormInput from "../../components/FormInput/FormInput";
import { useNavigate, useLocation } from "react-router-dom";
import toast from "react-simple-toasts";

export default function CustomEnquiry() {
  const classes = useStyles();
  const navigate = useNavigate();
  const location = useLocation();

  const [sort, setSort] = React.useState(0);

  const [loading, setLoading] = useState(false);
  const [totalList, setTotalList] = React.useState(1);
  const [pageNum, setPageNum] = React.useState(0);
  const [allCustomers, setAllCustomers] = useState([]);

  const [listData, setlistData] = React.useState(null);
  const [openDelete, setOpenDelete] = React.useState(false);
  const [selectedCustom, setSelectedCustom] = React.useState(null);

  const handleChangeSort = (event) => {
    setSort(event.target.value);
  };

  const [searchKey, setSearchKey] = React.useState("");
  const handleSearch = (event) => {
    setSearchKey(event.target.value);
    var _data = searchList(allCustomers, event.target.value);
    setlistData(_data);
    setTotalList(_data.length);
  };

  const getData = () => {
    setLoading(true);
    get_custom_made({
      page: pageNum + 1,
      // sort: sort
    }).then((json) => {
      setLoading(false);
      setAllCustomers(json.data);
      var _data = searchList(json.data, searchKey);
      setlistData(_data);
      setTotalList(_data.length);
      //   setTotalList(json.total)
    });
  };

  const searchList = (data, searchKey) => {
    var _data = [];
    if (searchKey != "") {
      for (var i = 0; i < data.length; i++) {
        if (
          data[i].apparel_pattern
            .toUpperCase()
            .indexOf(searchKey.toUpperCase()) > -1 ||
          data[i].name.toUpperCase().indexOf(searchKey.toUpperCase()) > -1 ||
          data[i].color.toUpperCase().indexOf(searchKey.toUpperCase()) > -1 ||
          data[i].decoration.toUpperCase().indexOf(searchKey.toUpperCase()) >
            -1 ||
          data[i].material.toUpperCase().indexOf(searchKey.toUpperCase()) > -1
        ) {
          _data.push(data[i]);
        }
      }
    } else {
      _data = data;
    }

    console.log(_data);
    return _data;
  };

  React.useEffect(() => {
    getData();
  }, [pageNum, sort]);

  const handleChangePage = (e, ispage) => {
    setPageNum(ispage);
    // getData();
  };

  const handleOpenDelete = (e) => {
    setOpenDelete(true);
    setSelectedCustom(e);
  };
  const handleCloseDelete = (value) => {
    setOpenDelete(false);
  };
  const handleDeleteCustom = () => {
    setLoading(true);
    delete_custom_made({ custom_made_id: selectedCustom }).then((json) => {
      if (json.status) {
        setLoading(false);
        toast("Custom Made Enquiry Deleted");
        handleCloseDelete();
        getData();
      } else {
        setLoading(false);
        toast(json.message);
      }
    });
  };

  return (
    <React.Fragment>
      {loading ? (
        <div style={{ margin: "auto" }}>
          <Loader type="bubble-loop" bgColor="#1A5386" size={50} />
        </div>
      ) : (
        <Navbar2
          children={
            <Section pd="2rem">
              <div>
                <div className={classes.theFlexHeader}>
                  <Paragraph color="#1A5386" bold="600" size="24px">
                    Custom Made Enquiry
                  </Paragraph>

                  <div
                    className={classes.theFlexBtn}
                    style={{ marginBottom: "0" }}
                  >
                    {/* <a
                      className={classes.theCustomActionBtn_}
                      onClick={() => handleOpenAdd()}
                    >
                      <AddCircle sx={{ color: '#1A5386' }} />
                      <Paragraph color='#1A5386' margin='0 0 0 .4rem'>
                        Add New Shipping Calculation Price
                      </Paragraph>
                    </a> */}
                    {/* <a
                                            className={classes.theCustomActionBtn_}
                                        // onClick={() => handleOpenStockMove()}
                                        >
                                            <ExitToApp sx={{ color: "#707070" }} />
                                            <Paragraph margin="0 0 0 .4rem">Export</Paragraph>
                                        </a> */}
                  </div>
                </div>
                <div
                  style={{
                    borderBottom: "2px solid #707070",
                    padding: ".2rem 0",
                  }}
                />
                <br />

                <div className={classes.theFlexAction}>
                  <div
                    className={classes.theWx}
                    style={{ margin: "0 20px 0 0" }}
                  >
                    <FormInputNoLabel
                      placeholder="Search"
                      border="1px solid #d7d7d7"
                      br="6px"
                      onChange={handleSearch}
                      value={searchKey}
                    />
                  </div>
                  {/* <div className={classes.theWx} style={{ margin: "0 20px 0 0" }}>
                            <FormInputNoLabel
                                placeholder="Search"
                                border="1px solid #d7d7d7"
                                br="6px"
                                onChange={(e) => console.log(e.target.value)}
                                value={searchKey}
                                type="date"
                            />
                        </div> */}
                  {/* <div className={classes.theWx}>
                            <div className={classes.theFlex_}>
                                <FormInputSelect>
                                    <Select
                                        labelId="demo-simple-select-label"
                                        id="demo-simple-select"
                                        value={sort}
                                        // defaultValue={sort}
                                        onChange={handleChangeSort}
                                    >
                                        <MenuItem value="0" style={{ color: "#000" }}>
                                            All Payment Type
                                        </MenuItem>
                                        <MenuItem value="1" style={{ color: "#000" }}>
                                            Paid
                                        </MenuItem>
                                        <MenuItem value="2" style={{ color: "#000" }}>
                                            On Hold
                                        </MenuItem>
                                        <MenuItem value="3" style={{ color: "#000" }}>
                                            Cancelled
                                        </MenuItem>
                                    </Select>
                                </FormInputSelect>
                            </div>
                        </div> */}
                </div>

                <Grid container spacing={3}>
                  <Grid item xs={12} sm={12} md={12}>
                    <Card className={classes.theCard}>
                      <TableContainer>
                        <Table>
                          <TableHead style={{ backgroundColor: "#1A5386" }}>
                            <TableRow>
                              <TableCell
                                style={{ borderRadius: "10px 0 0 10px" }}
                                className={classes.theHeadTitle}
                              >
                                Name
                              </TableCell>
                              <TableCell className={classes.theHeadTitle}>
                                Comapany Name
                              </TableCell>
                              <TableCell className={classes.theHeadTitle}>
                                Contact Number
                              </TableCell>
                              <TableCell className={classes.theHeadTitle}>
                                Email
                              </TableCell>
                              <TableCell className={classes.theHeadTitle}>
                                Apparel Pattern
                              </TableCell>
                              <TableCell className={classes.theHeadTitle}>
                                Color
                              </TableCell>
                              <TableCell className={classes.theHeadTitle}>
                                Decoration
                              </TableCell>
                              <TableCell className={classes.theHeadTitle}>
                                Material
                              </TableCell>
                              <TableCell
                                align="center"
                                style={{ borderRadius: "0 10px 10px 0" }}
                                className={classes.theHeadTitle}
                              >
                                <MoreVert sx={{ color: "#fff" }} />
                              </TableCell>
                            </TableRow>
                          </TableHead>
                          <TableBody>
                            {listData != null &&
                              listData
                                .slice(pageNum * 10, pageNum * 10 + 10)
                                .map((item, index) => {
                                  return (
                                    <TableRow>
                                      <a
                                        style={{ display: "contents" }}
                                        // href={`../saledetail/${item.sales_order_id}`}
                                      >
                                        <TableCell
                                          style={{
                                            // textDecoration: "underline",
                                            background:
                                              index % 2 == 0
                                                ? "#f2f2f2"
                                                : "#fff",
                                          }}
                                        >
                                          {item.name != "" && item.name != null
                                            ? item.name
                                            : "-"}
                                        </TableCell>
                                        <TableCell
                                          style={{
                                            background:
                                              index % 2 == 0
                                                ? "#f2f2f2"
                                                : "#fff",
                                          }}
                                        >
                                          {item.company != "" &&
                                          item.company != null
                                            ? item.company
                                            : "-"}
                                        </TableCell>
                                        <TableCell
                                          style={{
                                            background:
                                              index % 2 == 0
                                                ? "#f2f2f2"
                                                : "#fff",
                                          }}
                                        >
                                          {item.contact != "" &&
                                          item.contact != null
                                            ? item.contact
                                            : "-"}
                                        </TableCell>
                                        <TableCell
                                          style={{
                                            background:
                                              index % 2 == 0
                                                ? "#f2f2f2"
                                                : "#fff",
                                          }}
                                        >
                                          {item.email != "" &&
                                          item.email != null
                                            ? item.email
                                            : "-"}
                                        </TableCell>
                                        <TableCell
                                          style={{
                                            background:
                                              index % 2 == 0
                                                ? "#f2f2f2"
                                                : "#fff",
                                          }}
                                        >
                                          {item.apparel_pattern != "" &&
                                          item.apparel_pattern != null
                                            ? item.apparel_pattern
                                            : "-"}
                                        </TableCell>
                                        <TableCell
                                          style={{
                                            background:
                                              index % 2 == 0
                                                ? "#f2f2f2"
                                                : "#fff",
                                          }}
                                        >
                                          <Box
                                            sx={{
                                              display: "flex",
                                              alignItems: "center",
                                            }}
                                          >
                                            <div
                                              style={{
                                                width: "30px",
                                                height: "30px",
                                                borderRadius: "50px",
                                                background: item.color,
                                                marginRight: "12px",
                                              }}
                                            ></div>
                                            {item.color != "" &&
                                            item.color != null
                                              ? item.color
                                              : "-"}
                                          </Box>
                                        </TableCell>
                                        <TableCell
                                          style={{
                                            background:
                                              index % 2 == 0
                                                ? "#f2f2f2"
                                                : "#fff",
                                          }}
                                        >
                                          {item.decoration != "" &&
                                          item.decoration != null
                                            ? item.decoration
                                            : "-"}
                                        </TableCell>
                                        <TableCell
                                          style={{
                                            background:
                                              index % 2 == 0
                                                ? "#f2f2f2"
                                                : "#fff",
                                          }}
                                        >
                                          {item.material != "" &&
                                          item.material != null
                                            ? item.material
                                            : "-"}
                                        </TableCell>
                                        <TableCell
                                          align="center"
                                          style={{
                                            background:
                                              index % 2 == 0
                                                ? "#f2f2f2"
                                                : "#fff",
                                            width: "10%",
                                          }}
                                        >
                                          <Button
                                            onClick={() =>
                                              handleOpenDelete(
                                                item.custom_made_id
                                              )
                                            }
                                            label="Delete"
                                            color="#1A5386"
                                            bg="#fff"
                                            box="1px solid #1A5386"
                                            size="12px"
                                            pd="10px"
                                            br="5px"
                                          />
                                        </TableCell>
                                      </a>
                                    </TableRow>
                                  );
                                })}
                          </TableBody>
                        </Table>
                      </TableContainer>

                      <div
                        style={{
                          borderTop: "1px solid #707070",
                          borderBottom: "1px solid #707070",
                          margin: "1rem 0 0",
                          cursor: "pointer",
                          display: "flex",
                          justifyContent: "flex-end",
                          alignItems: "flex-end",
                        }}
                      >
                        <TablePagination
                          // variant="outlined"
                          color="primary"
                          page={pageNum}
                          onPageChange={handleChangePage}
                          count={totalList}
                          // defaultPage={pageList}
                          rowsPerPage={10}
                          rowsPerPageOptions={[10]}
                          // count={10}
                        />
                      </div>
                    </Card>
                    <br />
                    <br />
                  </Grid>
                </Grid>
                <br />
                <br />
              </div>

              <Dialog
                onClose={handleCloseDelete}
                open={openDelete}
                fullWidth="true"
                maxWidth="sm"
              >
                <DialogTitle>
                  <Paragraph color="#000" bold="600" size="24px">
                    Delete Enquiry
                  </Paragraph>
                </DialogTitle>
                <DialogContent>
                  <Paragraph
                    color="#000"
                    bold="600"
                    size="16px"
                    margin="0 0 1rem"
                  >
                    Are you sure to delete this enquiry?
                  </Paragraph>
                  <Button
                    onClick={() => handleDeleteCustom()}
                    label="Delete"
                    color="#fff"
                    bg="red"
                    size="18px"
                    pd="10px"
                    br="5px"
                    style={{ marginBottom: "10px" }}
                  />
                </DialogContent>
              </Dialog>
            </Section>
          }
        />
      )}
    </React.Fragment>
  );
}
